
import { recipeQueryService } from "./recipeQueryService";
import { recipeMutationService } from "./recipeMutationService";

/**
 * Consolidated recipe service that combines query and mutation services
 */
export const recipeService = {
  // Query methods
  getRecipes: recipeQueryService.getRecipes,
  getRecipeById: recipeQueryService.getRecipeById,
  getRecipesByIds: recipeQueryService.getRecipesByIds,
  getRecipeBySuggestionId: recipeQueryService.getRecipeBySuggestionId,
  
  // Mutation methods
  saveRecipe: recipeMutationService.saveRecipe,
  updateRecipe: recipeMutationService.updateRecipe,
  deleteRecipe: recipeMutationService.deleteRecipe
};

// Export individual services
export { recipeQueryService } from "./recipeQueryService";
export { recipeMutationService } from "./recipeMutationService";

// Export stats service and types
export { recipeStatsService, type RecipeWithStats } from "./recipeStatsService";

// Export default for consistency with other service modules
export default recipeService;
